import { render, staticRenderFns } from "./SelectCriteriaPassPage.vue?vue&type=template&id=51980a8b&"
import script from "./SelectCriteriaPassPage.vue?vue&type=script&lang=js&"
export * from "./SelectCriteriaPassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports